import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { ProductsService } from '../../services/products/products.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppState } from '../../app.reducer';
import { Store } from '@ngrx/store';
import { environment } from '@env/environment';
import { TransaccionCarrito } from '../../models/transaccionCarrito.model';

import { Encrypt } from '../../utils/encrypt/encrypt';
import { UserInformation } from '../../models/userInformation.model';
import { TagService } from '../../services/seoservice/tag.service';
import { DataLayerService } from 'src/app/services/dataLayer/data-layer.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { CcLoginComponent, CcRegisterComponent, PasswordRecoverComponent } from 'cc-components-lib';
import { WarningMessageModalComponent } from '../components/warning-message-modal/warning-message-modal.component';

@Component({
  selector: 'app-products-profile',
  templateUrl: './products-profile.component.html',
  styleUrls: ['./products-profile.component.scss']
})
export class ProductsProfileComponent implements OnInit {

  urlPublicaTuMismo: string = environment.urlPublishYourself;
  urlCalculaPrecio: string = environment.urlCalculatePriceOnline;
  isValue: number = 2;
  clienTypeSelected: string;
  idClientType: string = "";
  hideCardIsPN: boolean = false;
  transaccionCarrito: TransaccionCarrito;
  userInformation: UserInformation;

  public ccEnvironment: any;

  textTitle: string = 'Avisos clasificados - Servicios de anuncios publicitarios | Ciencuadras';
  textDescription: string = 'Selecciona tu perfil y accede a los planes de anuncios clasificados para Inmuebles en Venta, Arriendo o Proyectos de vivienda. Publica tu clasificado en ciencuadras';

  constructor(private cookieCiencuadras: CookieCiencuadras,
    private productsService: ProductsService,
    private store: Store<AppState>,
    private router: Router,
    private tagService: TagService,
    private dataLayerService: DataLayerService,
    private dialog: MatDialog
  ) {
    this.tagService.insertSEO(this.textTitle, this.textDescription, 'productos/');
    this.ccEnvironment = environment;

  }

  async ngOnInit(): Promise<void> {

    console.log('---------- ENVIROMENT ----------');
    console.log(environment.environmenturl);
    console.log('---------- ENVIROMENT ----------');

    let cripto = new Encrypt();
    // let prueba = cripto.decryptDataIV('T4vTRmbhT_wNny7OWyz-RFCsl3DGkHRDG9p6Si2f8LoiFNvp2yqiMHGryPPpXNHBSbEtjsQZemzIQLVZM2gYhIXxRNfp0rd3Ilt7GS24iqQGE8swJcMLVdPxhmfHMd8wboJwPvW_EKUygyFVS-XaMdqwt2PpHiugqRV5xHZMJDSZsw8dlD_Kvc1Z3xsAYSW5W6cdBkka6hRJraJKau4dGsu3B3MGLcGQb3YcVpsE6wd_fi-RBrAl_YgHbXz6wLCMSoabSiw1KcjaXMmW5bfM0T8MX8HftoIMXs0KMrWQpZHOh20uIgFnH6aZR0EQDEIm');
    // console.log('prueba: ', prueba);

    //  "T4vTRmbhT_wNny7OWyz-RFCsl3DGkHRDG9p6Si2f8LoiFNvp2yqiMHGryPPpXNHBSbEtjsQZemzIQLVZM2gYhIXxRNfp0rd3Ilt7GS24iqQGE8swJcMLVdPxhmfHMd8wboJwPvW_EKUygyFVS-XaMdqwt2PpHiugqRV5xHZMJDSZsw8dlD_Kvc1Z3xsAYSW5W6cdBkka6hRJraJKau4dGsu3B3MGLcGQb3YcVpsE6wd_fi-RBrAl_YgHbXz6wLCMSoabSiw1KcjaXMmW5bfM0T8MX8HftoIMXs0KMrWQpZHOh20uIgFnH6aZR0EQDEIm"

    this.clienTypeSelected = this.cookieCiencuadras.getCookie('clientType');
    this.isValue = parseInt(this.cookieCiencuadras.getCookie('clientType'));
    this.cookieCiencuadras.removeCookie('selectedPlan');

    //  const token = localStorage.getItem('tokenProduct');
    const token = this.cookieCiencuadras.getCookie('tokenProduct');

    console.log('token: ', token);
    const userInfo = this.productsService.getLoginUserTypeAndUserType(this.clienTypeSelected);
    this.dataLayerService.onPushDataLayer({
      'event': 'elegir_tipo_usuario',
      'tipo de usuario': userInfo.userType
    });
    this.idClientType = this.productsService.setIdclientType();
    this.hideCardPN();

    if (token) {
      await this.getTransaction(token);
    }
  }

  selectProfile(n: number, label: string = '') {
    this.cookieCiencuadras.removeCookie('clientType');
    this.dataLayerService.pushTagEventClick({ 'event': 'ga_event', 'category': 'productos', 'action': 'CCW - selecciona perfil', 'label': label });
    this.isValue = n;

    this.clienTypeSelected = `${n}`;
    this.cookieCiencuadras.setCookie('clientType', this.clienTypeSelected);
    localStorage.setItem('clientType', this.clienTypeSelected);

    const userInfo = this.productsService.getLoginUserTypeAndUserType(this.clienTypeSelected);
    this.dataLayerService.onPushDataLayer({
      'event': 'elegir_tipo_usuario',
      'tipo de usuario': userInfo.userType
    });
    this.idClientType = this.productsService.setIdclientType();
    this.hideCardPN();
  }

  hideCardPN(){
    this.idClientType = this.cookieCiencuadras.getCookie('idClientType');
    if(this.clienTypeSelected === "4" && this.idClientType === "4"){
      this.isValue = parseInt(this.clienTypeSelected);
      this.hideCardIsPN = true;
      this.dialog.closeAll();
    }else if(this.clienTypeSelected === "4" && this.idClientType !== ""){
      this.hideCardIsPN = false;
      this.openInfoDialog();
    }else if(this.clienTypeSelected === "4"  && this.idClientType === ""){
      this.isValue = parseInt(this.clienTypeSelected);
      this.hideCardIsPN = true;
    }else{
      this.hideCardIsPN = true;
    }
  }

  selectPlanType(n: number, action: string = '', label: string = '') {
    this.dataLayerService.pushTagEventClick({ 'event': 'ga_event', 'category': 'productos', 'action': `CCW - ${action}`, 'label': label });
    this.cookieCiencuadras.setCookie('planType', n.toString());
  }

  async getTransaction(token: string) {


    await this.productsService.getTransaccionCarritoByToken(
      token
    ).then((res) => {
      console.log('------------------', res);
      if (res.status === 'ok') {
        this.transaccionCarrito = res;
        if (res.transaccionCarritoDTO.transactionStatusId !== 1) {
          localStorage.setItem('paymentStatus', JSON.stringify(this.transaccionCarrito));
          this.router.navigateByUrl('/productos-feedback');
        }
      }
    }).catch((err: HttpErrorResponse) => {

      if (err.error instanceof Error) {

        console.log('An error occurred:', err.error.message);
      }
      else {

        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });
    return Promise.resolve(true);
  }

  public setDataLayerPerson() {
    this.dataLayerService.onPushDataLayer({'event':'ga_event','category':'productos','action':'CCW - publica','label':'publica tu mismo'});
  }

  openInfoDialog(){
    const infoConfig = new MatDialogConfig();
    infoConfig.panelClass = 'detail-modal';
    infoConfig.maxWidth = '100vw';
    infoConfig.hasBackdrop = true;
    infoConfig.disableClose = true;
    this.dialog.open(WarningMessageModalComponent, infoConfig);
  }

  OpenOnboardingModal(Onboarding: any){
    console.log("event onboarding -->", Onboarding);

    this.dialog.closeAll();
    if(Onboarding.modal == 1){
      console.log("Onboarding.modal-->", Onboarding.modal);
      this.OpenLoginModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    }
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialog.open(CcLoginComponent, {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });

  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialog.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialog.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

}
